import GeneralTranslations from "../../../Common/ModuleTranslations/es";

export default {
  locale: "es",
  name: "Display",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "active",
        displayName: "Activo",
      },
      {
        fieldName: "conditions",
        displayName: "Condiciones",
      },
      {
        fieldName: "position",
        displayName: "Orden",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "active",
        displayName: "Activo",
        helpText: "¿Es visible el display en el motor?",
      },
      {
        fieldName: "defaultOption",
        displayName: "Se abre por defecto",
      },
      {
        fieldName: "startDate",
        displayName: "Fecha inicio de contratación",
        placeholder: "Introducir fecha",
      },
      {
        fieldName: "endDate",
        displayName: "Fecha fin de contratación",
        placeholder: "Introducir fecha",
      },
      {
        fieldName: "entityFilter",
        displayName: "Mostrar solo para:",
        optionDisplay: {
          PROPERTY: {
            label: "Establecimiento",
          },
          ACCOMMODATION: {
            label: "Alojamiento",
          },
        },
        helpText: "Solo será visible para elementos de este tipo",
      },
      {
        fieldName: "tickerFilter",
        displayName: "Mostrar solo para los siguientes identificadores (separados por comas):",
      },
      {
        fieldName: "label",
        displayName: "Nombre etiqueta",
      },
      {
        fieldName: "youTubeURL",
        displayName: "URL de Youtube",
      },
      {
        fieldName: "contentType",
        displayName: "Tipo de contenido",
        widget: "selector",
        optionDisplay: {
          HTML: {
            label: "HTML",
          },
          VIDEO: {
            label: "Video",
          },
          IMAGE: {
            label: "Imagen",
          },
        },
        defaultValue: "HTML",
      },
      {
        fieldName: "imageManager",
        displayName: "Imagen",
      },
      {
        fieldName: "content",
        displayName: "Contenido",
      },
    ],
  },
};
